import React from "react";
import BackImg from "@assets/images/stepsBack.jpg";
import ContactUsForm from "@components/common/ContactUsForm";

const Contact = () => {
  return (
    <div
      className={`bg-cover rounded-[17px] py-[100px] px-7 `}
      style={{ backgroundImage: `url(${BackImg})` }}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px]">
        <div className="flex flex-col justify-center">
          <h1 className="text-white font-[800] font-[Lato] text-[28px]">
            Contact Information
          </h1>
          <p className="text-white font-[400] font-[Lato] text-[18px] mt-2">
            Got a question? Chances are you’ll find the answer right away! Check
            out our FAQ page or ask FitBot, our smart virtual coach. FitBot is
            available 24/7 and can instantly assist you with anything related to
            nutrition, exercise, sleep, and mindfulness.
          </p>
          <h1 className="text-white font-[800] font-[Lato] text-[28px] mt-[50px]">
            Still need help?
          </h1>
          <p className="text-white font-[400] font-[Lato] text-[18px] mt-2">
            No problem! Fill out the contact form, and our team will get back to
            you within 24 hours. We're here to support you on your journey to a
            healthier and fitter life! 💪😊
          </p>
        </div>
        <ContactUsForm />
      </div>
    </div>
  );
};

export default Contact;
